<template>
  <div>
    <div class="header">
      <div id="tabs" class="deskTabs" :style="desktopStatus == true ? 'padding: 0px 335px 0px 0px;' : ''">
        <el-tabs v-model="tabIndex" type="card" @tab-click="changeTabIndex()" @tab-remove="removeTab">
          <el-tab-pane v-for="(item, index) in editableTabs2" :key="index+item.name" :closable="item.name ==='stage-index'?false:true" :label="item.title" :name="item.name">
          </el-tab-pane>
        </el-tabs>
      </div>
      <audio id="audio" class="newAudio" src="static/audio/audio.wav"></audio>
      <div class="chooseShop">
        <i class="iconfont downloadIcon" style="cursor: default;">&#xe694;</i>
        <div v-popover:popover4 class="shopList">
          <span>{{ shopValue }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-popover ref="popover4" placement="bottom-end" :open-delay="showTime" trigger="click" :offset="30">
          <div class="topMenu">
            <ul style="border-bottom: 0;padding: 0 0 10px 0;">
              <li v-for="(item,index) in storeList" :key="index" @click="changeShopValue(item.id,item.shopName)">
                <i v-if="shopValue == item.shopName" class="iconfont" :class="shopValue == item.shopName ? 'themeFC' : ''">&#xe610;</i>
                <span :class="shopValue == item.shopName ? 'themeFC' : ''" :style="shopValue == item.shopName ? 'padding-left: 9px;' : ''">{{ item.shopName }}</span>
              </li>
            </ul>
          </div>
        </el-popover>
        <span v-if="menusList.find(data => data.iDenTi === 'beauty-1-sp')">
          <samp v-popover:popover2 class="hand" @click="getHandList">牌</samp>
        </span>
        <el-dialog width="596px" title="手牌列表" :visible.sync="handDialog" :append-to-body="true">
          <div class="handList">
            <ul v-if="handInfo.cardNumber > 0">
              <el-popover v-for="(v,n) in handInfo.cards" v-show="v.status" :key="n" placement="bottom-start" trigger="hover">
                <div class="pd_20">
                  <p class="mb_20">该订单关联{{ handInfo.chooseNum }}个手牌</p>
                  <div style="text-align: right; margin: 0">
                    <yz-btn type="delete" @click="seeOrder(v)">详情</yz-btn>
                    <yz-btn type="delete" @click="editOrder(v.orderId)">修改</yz-btn>
                    <yz-btn v-if="v.isDelete == 1 ? true : false" type="delete" @click="delOrder(v.orderId,v.orderType)">删除</yz-btn>
                    <yz-btn type="primary" @click="settlementOrder(v.orderId)">结算</yz-btn>
                  </div>
                </div>
                <li slot="reference" :class="v.choose == 0 ? '' : 'handChoose'" @mouseover="chooseHand(v.orderId)">{{ v.handCardNumber }}</li>
              </el-popover>
            </ul>
            <p v-else>暂无正在使用的手牌~</p>
          </div>
        </el-dialog>
        <el-dialog :title="'订单号-'+orderCode+'--'+orderTypeName" :visible.sync="orderDeatilsDialog" :append-to-body="true" width="1000px">
          <yzOrderDeatils :order-deatils-data="orderDeatilsData" :order-deatils-dialog="orderDeatilsDialog" :loading="loading2" @newGetListData="newGetListData" @tansferDialog="getDialogData" />
        </el-dialog>
        <gt-delDig @delData="getDelData"></gt-delDig>
        <span v-if="showStatus == 2">
          <el-popover ref="popover5" :disabled="socketBespeakStatus == 1 ? false : true" placement="bottom-end" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
            <div class="topLi">
              <img src="static/images/icon/top_05.png" />
              <span>您有新的预约订单，请注意
                <samp class="themeFC" @click="lookBespeakOrder">查看</samp>
              </span>
            </div>
          </el-popover>
          <samp id="socketBespeakStatus" :class="deadlineStatus == 'true' ? 'bespeakNum bespeakNumX' : 'bespeakNum'" style="display: none;right: 19px;margin-top: -5px;"></samp>
          <img v-popover:popover5 class="printer" style="margin: 9px 10px;" src="static/images/icon/top_02.png" @click="lookBespeakOrder" />
        </span>
        <span>
          <el-popover ref="popover7" placement="bottom-end" :open-delay="showTime" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
            <div class="topMenu">
              <div class="loginInfo">
                <img :src="shopImg ? shopImg : 'static/images/yangzi.png'" />
                <h1>{{ accountName }}</h1>
                <h2>{{ account }}</h2>
              </div>
              <div v-if="menusList.find(data => data.iDenTi === 'beauty-2-ckpj')" class="outLogin" @click="lookCommentList">
                <img src="static/images/icon/top_07.png" />
                <span>查看评价</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <gt-theme></gt-theme>
              <div v-popover:popover1 class="outLogin" :style="desktopStatus == false ? '' : 'border-bottom: 0;'">
                <img src="static/images/icon/top_03.png" />
                <span>粉丝端</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <el-popover ref="popover1" placement="left-start" popper-class="offset_25" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                <ul class="indexEqcode">
                  <li v-if="busQRCodeData.appUrl">
                    <h3>粉丝端</h3>
                    <h4>微信扫码进入</h4>
                    <img :src="busQRCodeData.appUrl" class="wximg" @click="Lib.enlarge(busQRCodeData.appUrl)" />
                    <h5>{{ busQRCodeData.nickName || '小程序' }}</h5>
                  </li>
                  <li v-else>
                    <div class="fansInfo">
                      <p>开通粉丝端小程序</p>
                      <p>获取更多客源！</p>
                    </div>
                    <h6>请前往后台进行设置</h6>
                  </li>
                  <li>
                    <h3></h3>
                    <h4></h4>
                    <img :src="busQRCodeData.h5Url" @click="Lib.enlarge(busQRCodeData.h5Url)" />
                    <h5>门店链接</h5>
                  </li>
                </ul>
              </el-popover>
              <div v-if="desktopStatus == false" class="outLogin" @click="openPage()">
                <i class="iconfont moreIcon">&#xe67a;</i>
                <span>客户端下载</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div v-if="desktopStatus == false" class="outLogin" @click="outLogin">
                <img src="static/images/icon/top_04.png" />
                <span>退出登录</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </el-popover>
          <i v-popover:popover7 class="iconfont" style="cursor: pointer;">&#xe61f;</i>
        </span>
      </div>
    </div>
    <div id="closeMenu" style="display: none">
      <ul>
        <li @click="closeAllWindow">关闭全部窗口</li>
        <li :class="{showDisable: disable}" @click="closeThis">关闭当前窗口</li>
        <li :class="{showDisable: disable}" @click="closeLeft">关闭左边窗口</li>
        <li @click="closeRight">关闭右边窗口</li>
      </ul>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import tabRouters from '@/router/routers';
import DfSocket from 'df-plugins/src/socket/index.js';
import yzOrderDeatils from '../../stage/template/orderDetails/index';
import {
  getOutLogin, getChangeStore, getBusQRCode, savePrintSetId, getBookReadStatus, getIndexMsg, getErpLoginUrl, getCommonName, getHandCards,
  // getOrderDetail4AllDto,
  getToken
} from '../api';

export default {
  name: 'YzTop',
  components: {
    yzOrderDeatils
  },
  props: {
    storeList: {
      type: Array,
      default: Array
    },
    shopImg: {
      type: String,
      default: String
    },
    account: {
      type: String,
      default: String
    },
    accountName: {
      type: String,
      default: String
    },
    logoUrl: {
      type: String,
      default: String
    },
    erpType: {
      type: String,
      default: String
    },
    showBuletin: {
      type: Boolean
    },
    bulletinNum: {
      type: Number,
      default: Number
    },
    commentNum: {
      type: Number,
      default: Number
    },
    menusList: {
      type: Array,
      default: Array
    },
    desktopStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shopValue: '',
      editableTabs2: [
        {
          title: '前台',
          name: 'stage-index'
        }
      ],
      tabIndex: '',
      busQRCodeData: '',
      clearTime: null,
      disable: false,
      editableTabsValue: '',
      printerRadio: [], // 选择的打印机
      printerList: [], // 打印机列表
      uaValue: '', // 判断是手机端还是PC端   pc为PC端，mobile为手机端
      bulletinNum2: 0,
      showTime: 2000, // 显示气泡的时间  单位毫秒
      showStatus: '',
      // commentNum: 0
      deadlineStatus: 'false',
      socketBespeakStatus: 0,
      // 5.9
      handInfo: {
        cardNumber: 0,
        chooseNum: 0,
        cards: []
      },
      handDialog: false,

      delForm: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'deleteOrder',
        text1: '',
        text2: '',
        status: false
      },
      orderDeatilsDialog: false,
      orderCode: '',
      orderTypeName: '', // 订单类型名称
      orderDeatilsData: {
        itemList: [],
        payTypeList: []
      },
      loading2: true,
    };
  },
  watch: {
    // 全局监听删除tabs
    '$store.state.deleteTabsItem.change': function () {
      clearTimeout(this.clearTime);
      this.clearTime = setTimeout(() => {
        const its = this.$store.state.deleteTabsItem.item;
        const tabs = window.JSON.parse(window.JSON.stringify(this.editableTabs2));
        tabs.forEach((item, index) => {
          if (its === item.name) {
            tabs.splice(index, 1);
          }
        });
        this.editableTabs2 = tabs;
        window.sessionStorage.yzTableList = window.JSON.stringify({
          editableTabs2: tabs,
          tabIndex: this.tabIndex
        });
        window.sessionStorage.previousRecord = window.JSON.stringify(tabs);
      }, 500);
    },
    // 监听router
    $route(e) {
      this.getTodayData();
      $('.el-dialog__headerbtn').click();
      const tabItem = this.getTabItem(e);
      if (!tabItem.name) return;
      let flag = true;
      this.editableTabs2.forEach((item) => {
        if (tabItem.name === item.name) {
          flag = false;
          tabItem.name = item.name;
        }
        if (tabItem.title === item.title) {
          flag = false;
          item.name = e.name;
        }
      });
      const list = window.sessionStorage.previousRecord ? window.JSON.parse(window.sessionStorage.previousRecord) : this.editableTabs2;
      if (flag) {
        this.editableTabs2.push(tabItem);
        list.push(tabItem);
      } else {
        list.forEach((a, b) => {
          if (tabItem.name == a.name || tabItem.title == a.title) {
            list.splice(b, 1);
          }
        });
        list.push(tabItem);
      }
      this.tabIndex = tabItem.name;
      const tabDetail = {
        editableTabs2: this.editableTabs2,
        tabIndex: this.tabIndex
      };
      window.sessionStorage.yzTableList = window.JSON.stringify(tabDetail);
      window.sessionStorage.previousRecord = window.JSON.stringify(list);
    },
    '$store.state.mainId': function () {
      this.getIdSelectName();
      this.getBusQRCode();
      getCommonName({ mainId: sessionStorage.getItem('mainId') }).then((res) => {
        if (res.code == 0) {
          window.sessionStorage.collectively = res.data.commonName;
        }
      });
    },
    'delForm.delDiglogStatus': function (val) {
      if (val == false) {
        this.getHandList();
      }
    }
  },
  mounted() {
    const vm = this;
    // 屏蔽浏览器右键菜单
    document.oncontextmenu = function () {
      return false;
    };
    // 按下鼠标
    $('#tabs').on('mousedown', '.el-tabs__item', function (e) {
      const key = e.which; // 获取鼠标键位
      if (key == 3) { // (1:代表左键； 2:代表中键； 3:代表右键)
        vm.editableTabsValue = $(this).text();
        if (vm.editableTabsValue == '前台') {
          vm.disable = true;
        } else {
          vm.disable = false;
        }
        vm.editableTabs2.forEach((val) => {
          if (vm.editableTabsValue == val.title) {
            vm.$router.push({ name: val.name });
          }
        });
        // 获取右键点击坐标
        const x = e.clientX + 10;
        const y = e.clientY + 8;
        $('#closeMenu').show().css({ left: x, top: y });
      }
    });
    $(document).click(() => {
      $('#closeMenu').hide();
    });
    const { yzTableList } = window.sessionStorage;
    if (!yzTableList) return;
    const tabDetail = window.JSON.parse(yzTableList);
    this.editableTabs2 = tabDetail.editableTabs2;
    if (this.$isDesktop() === true) {
      this.tabIndex = 'stage-index';
      this.changeTabIndex();
    } else {
      // this.tabIndex = tabDetail.tabIndex;
      this.changeTabIndex();
    }
  },
  updated() {
    this.showStatus = window.sessionStorage.setUrlStatus;
    this.deadlineStatus = window.sessionStorage.deadlineStatus;
  },
  created() {
    if (this.showStatus == 1) {
      this.$router.push({
        name: 'stage-index'
      });
      const tabDetail = {
        editableTabs2: [
          {
            title: '前台',
            name: 'stage-index'
          }
        ],
        tabIndex: 'stage-index'
      };
      window.sessionStorage.yzTableList = window.JSON.stringify(tabDetail);
      window.sessionStorage.previousRecord = window.JSON.stringify(tabDetail.editableTabs2);
      return;
    }
    this.uaValue = this.Lib.pcOrMobile();
    this.shopValue = window.sessionStorage.shopValue;
    setTimeout(() => {
      this.listenSocket();
      this.getTodayData();
      this.showTime = 100;
    }, 1000);
  },

  methods: {
    // 调用公共组件--赋值--5.9
    getDialogData(list) {
      this.orderDeatilsDialog = list;
    },
    // 子父组件赋值--5.9
    newGetListData() {
      this.getListData();
      this.$emit('getDelStatus', true);
    },
    // 调用公共组件--赋值--5.9
    getDelData(list) {
      this.delForm = list;
    },
    // 查看订单
    seeOrder(v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },
    // 删除订单--5.9
    delOrder(id, type) {
      if (this.Lib.checkPower('beauty-2-scddsp') == false) return;
      this.delForm.delDiglogStatus = true;
      this.delForm.id = id;
      this.delForm.title = '提示';
      this.delForm.url = type == 2 ? 'deleteQuickOrder' : 'deleteOrder';
      this.delForm.text1 = '确认要删除这条订单吗？';
      this.delForm.text2 = '删除后订单数据将无法恢复';
      this.delForm.status = false;
    },
    // 结算订单--5.9
    settlementOrder(id) {
      if (this.Lib.checkPower('beauty-2-jsddsp') == false) return;
      window.sessionStorage.settlementOrderId = id;
      this.$router.push({
        name: 'stage-orderSettlement',
        params: {
          partPay: 0
        }
      });
    },
    // 修改订单--5.9
    editOrder(id) {
      if (this.Lib.checkPower('beauty-2-xgddsp') == false) return;
      window.sessionStorage.editOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling',
      });
    },
    // 选择手牌--5.9
    chooseHand(id) {
      let num = 0;
      this.handInfo.cards.forEach((a) => {
        if (a.orderId == id) {
          a.choose = 1;
          num++;
        } else {
          a.choose = 0;
        }
      });
      this.handInfo.chooseNum = num;
    },
    // 获取手牌列表数据--5.9
    getHandList() {
      if (this.Lib.checkPower('beauty-2-ckddsp') == false) return;
      this.lookHand();
      const data = { mainId: sessionStorage.getItem('mainId'), type: 2 };
      getHandCards(data).then((res) => {
        if (res.code == 0) {
          res.data.cards.forEach((a) => {
            a.choose = 0;
          });
          this.handInfo = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 查看手牌--5.9
    lookHand() {
      this.handDialog = true;
    },
    changeTabIndex() {
      if ((!this.tabIndex || this.tabIndex == 0) && (window.location.href.split('?')[0].split('#')[1] == '/finance/income')) {
        const tabDetail = {
          editableTabs2: [{
            title: '前台',
            name: 'stage-index'
          }, {
            title: '营业统计',
            name: 'finance-income'
          }],
          tabIndex: 'finance-income'
        };
        this.editableTabs2 = tabDetail.editableTabs2;
        window.sessionStorage.yzTableList = window.JSON.stringify(tabDetail);
        window.sessionStorage.previousRecord = window.JSON.stringify(tabDetail.editableTabs2);
        this.tabIndex = 'finance-income';
      } else {
        this.tabIndex = (!this.tabIndex || this.tabIndex == 0) ? 'stage-index' : this.tabIndex;
      }
      this.$router.push({
        name: this.tabIndex
      });
    },
    // 客户端下载
    openPage() {
      window.open('https://www.duofriend.com/intro/download');
    },
    // 查看预约订单
    lookBespeakOrder() {
      if (this.Lib.checkPower('beauty-1-yy') == false) return;
      this.$router.push({
        name: 'stage-allDay'
      });
    },
    // 点击查看评价
    lookCommentList() {
      this.$emit('lookCommentList', 0);
    },
    // socket监听新预约订单
    listenSocket() {
      const vm = this;
      getBookReadStatus().then((res) => {
        if (res.data === 'true') {
          $('#socketBespeakStatus').css('display', 'block');
          vm.socketBespeakStatus = 1;
          vm.Lib.playAudio();
        }
      });
      if (sessionStorage.getItem('token')) {
        const socketOptions = {
          scene: `/push?scene=1&tags=beauty-${sessionStorage.getItem('mainId')}&token=${sessionStorage.getItem('token')}`,
          messageTags: [`beauty-${sessionStorage.getItem('mainId')}`],
          message(sdata) {
            vm.callback(sdata.payload);
          }, // socket推送的数据
          connect() {},
          disconnect() {}, // 连接断开
          reconnectFailed() {}, // 重连失败
          error() {}, // 连接失败错误信息
        };
        new DfSocket(socketOptions).start(); // 开始连接
      } else {
        getToken().then((res) => {
          const socketOptions = {
            scene: `/push?scene=1&tags=beauty-${sessionStorage.getItem('mainId')}&token=${res.data}`,
            messageTags: [`beauty-${sessionStorage.getItem('mainId')}`],
            message(sdata) {
              vm.callback(sdata.payload);
            }, // socket推送的数据
            connect() {},
            disconnect() {}, // 连接断开
            reconnectFailed() {}, // 重连失败
            error() {}, // 连接失败错误信息
          };
          new DfSocket(socketOptions).start(); // 开始连接
        });
      }
    },
    // socket回调监听
    callback(data) {
      // 有预约信息
      if (data.code == 0) {
        $('#socketBespeakStatus').text($('#socketBespeakStatus').text() * 1 + 1);
        $('#socketBespeakStatus').css('display', 'block');
        this.socketBespeakStatus = 1;
        this.Lib.playAudio();
      }
    },
    // //公告socket2回调监听
    // callback2(data) {
    //     if (data.code == 0) {
    //         this.bulletinNum++
    //     }
    // },
    // //评价socket2回调监听
    // callback3(data) {
    //     if (data.code == 0) {
    //         this.commentNum++
    //     }
    // },
    // 根据storeId选择name
    getIdSelectName() {
      const list = this.storeList;
      const nid = this.$store.state.mainId;
      list.forEach((item) => {
        if (nid == item.id) {
          this.shopValue = item.shopName;
        }
      });
    },
    // 获取预约数量
    getTodayData() {
      getIndexMsg({}).then((res) => {
        $('#socketBespeakStatus').text(res.data ? res.data.noReadCount : '0');
        setTimeout(() => {
          this.socketBespeakStatus = res.data ? (res.data.noReadCount * 1 > 0) ? 1 : 0 : 0;
        }, 30);
      });
    },
    // 选择门店
    changeShopValue(id, name) {
      getChangeStore({
        storeId: id
      }).then((res) => {
        if (res.code == 0) {
          window.sessionStorage.mainId = id;
          setTimeout(() => {
            Object.assign(this.$data, this.$options.data());
            window.sessionStorage.rechargePhone = '';
            this.shopValue = name;
            window.sessionStorage.shopValue = this.shopValue;
            const tabDetail = {
              editableTabs2: [
                {
                  title: '前台',
                  name: 'stage-index'
                }
              ],
              tabIndex: 'stage-index'
            };
            window.sessionStorage.yzTableList = window.JSON.stringify(tabDetail);
            this.$router.replace({
              name: 'stage-index'
            });
            this.$emit('startLoadData', 0);
            window.location.reload();
          }, 100);
        }
      });
    },
    // 根据name匹配拿到title和router - name
    getTabItem(e) {
      const tab = {};
      // params
      console.log(tabRouters);
      tabRouters.forEach((a) => {
        if (a.children) {
          a.children.forEach((b) => {
            if (e.name === b.name) {
              tab.title = e.params ? e.params.newTitle ? e.params.newTitle : b.title : b.title;
              tab.name = b.name;
            }
          });
        } else if (e.name === a.name) {
          tab.title = e.params ? e.params.newTitle ? e.params.newTitle : a.title : a.title;
          tab.name = a.name;
        }
      });
      return tab;
    },
    // 删除标签
    removeTab(e) {
      const list = window.JSON.parse(window.sessionStorage.previousRecord);
      this.editableTabs2.forEach((item, index) => {
        if (e == item.name || e == item.title) {
          this.editableTabs2.splice(index, 1);
        }
      });
      list.forEach((a, b) => {
        if (e == a.name || e == a.title) {
          list.splice(b, 1);
          this.tabIndex = list[list.length - 1].name;
        }
      });
      window.sessionStorage.previousRecord = window.JSON.stringify(list);
      window.sessionStorage.yzTableList = window.JSON.stringify({
        editableTabs2: this.editableTabs2,
        tabIndex: this.tabIndex
      });
      this.changeTabIndex();
    },
    // 关闭全部窗口
    closeAllWindow() {
      const vm = this;
      const tab = [];
      let link = '';
      vm.editableTabs2.forEach((val) => {
        if (val.title == '前台') {
          tab.push(val);
          link = val.name;
        }
      });
      vm.editableTabs2 = tab;
      vm.editableTabsValue = '前台';
      window.sessionStorage.yzTableList = window.JSON.stringify({
        editableTabs2: vm.editableTabs2
      });
      window.sessionStorage.previousRecord = window.JSON.stringify(vm.editableTabs2);
      vm.$router.push({ name: link });
    },
    // 关闭右侧窗口
    closeRight() {
      const vm = this;
      let flag = false;
      const removeTabs = [];
      vm.editableTabs2.filter((t) => {
        if (t.title == vm.editableTabsValue && !flag) {
          flag = true;
        }
        if (flag && t.title != vm.editableTabsValue) {
          removeTabs.push(t.name);
        }
      });
      removeTabs.forEach((v) => {
        vm.removeTab(v);
      });
    },
    // 关闭当前窗口
    closeThis() {
      if (this.disable == true) return;
      this.removeTab(this.editableTabsValue);
    },
    // 关闭左侧的
    closeLeft() {
      const vm = this;
      const data = vm.editableTabs2;
      const removeTabs = [];
      for (let i = 0; data.length > 0; i++) {
        if (data[i].title == '前台') {
          // return
        } else if (data[i].title !== vm.editableTabsValue) {
          removeTabs.push(data[i].name);
        } else {
          removeTabs.forEach((v) => {
            vm.removeTab(v);
          });
          return;
        }
      }
      // var num = 0
      // data.forEach((a,n) => {
      //   if(a.title === vm.editableTabsValue) {
      //     num = n
      //   }
      // });
      // data.forEach((a,n) => {
      //   if(a.title !== vm.editableTabsValue && a.title !== '前台' && (num > n)) {
      //     removeTabs.push(a.title)
      //   }
      // });
      // console.log(removeTabs)
      // removeTabs.forEach(v => {
      //   vm.removeTab(v);
      // })
    },
    // 退出
    outLogin() {
      const status = this.Lib.pcOrMobile();
      if (status === 'mobile') {
        if (window.webkit) {
          window.webkit.messageHandlers.register.postMessage(null);
        } else if (typeof (dfAndroidAppHD) != 'undefined') {
          // eslint-disable-next-line no-undef
          dfAndroidAppHD.register();
        }
      } else {
        getOutLogin().then((response) => {
          if (response.code == 0) {
            getErpLoginUrl().then((res) => {
              if (res.code == 0) {
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = `${res.data}/jsp/login/out/exit.html?proIDen=5EEx+rTdFv/5kj/TK0A9DJ5xUSmGIq+E`;
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$message.error(response.msg);
          }
        });
      }
    },
    // 获取二维码
    getBusQRCode() {
      getBusQRCode().then((res) => {
        res ? res.code == 0 ? this.busQRCodeData = res.data : console.log(res.msg) : console.log(res);
      });
    },
    // //获取打印机列表
    // getPrinterList() {
    //     getPrintSetList().then(res => {
    //         if (res && res.code == 0) {
    //             this.printerList = res.data.list
    //             var arr = []
    //             var printIdList = res.data.printId ? res.data.printId.split(',') : []
    //             printIdList.forEach(item => {
    //                 arr.push(item * 1)
    //             });
    //             this.printerRadio = arr
    //             window.sessionStorage.printId = res.data.printId ? res.data.printId : ''
    //         }
    //     })
    // },
    // 保存打印机id
    changePrintSetId(val) {
      let arr = '';
      if (val.length > 0) {
        val.forEach((item, index) => {
          if (val.length == (index + 1)) {
            arr += item;
          } else {
            arr += `${item},`;
          }
        });
      }
      const data = { setId: arr };
      savePrintSetId(data).then((res) => {
        if (res.code === 0) {
          /// /console.log('设置打印机成功')
        }
      });
    },

  }
};
</script>

<style lang="less" scoped>
.title {
  float: left;
}
.header {
  height: 39px;
  line-height: 39px;
  padding: 0 20px 0 0;
  border-bottom: 1px solid #eee;
  .title {
    color: #333;
    font-size: 15px;
    float: left;
  }
  .chooseShop {
    position: fixed;
    right: 22px;
    top: 0;
    max-width: 360px;
  }
}
.handList{
  min-height: 240px;
  display: flex;
  ul {
    list-style-type: none;
    li {
      float: left;
      width: 88px;
      height: 98px;
      line-height: 98px;
      text-align: center;
      border-radius: 4px;
      margin: 0 20px 20px 0;
      cursor: pointer;
    }
    span:nth-child(5n) li {
      margin-right: 0;
    }
  }
  p {
    width: 100%;
    text-align: center;
    height: 223px;
    line-height: 223px;
    padding-bottom: 17px;
    color: #333;
    font-size: 14px;
  }
}
.hand {
  float: left;
  font-size: 12px;
  border: 1px solid #ABABAB;
  color: #ABABAB;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin: 9px 10px;
  border-radius: 50%;
  cursor: pointer;
}
.indexEqcode {
  padding: 12px;
}
.indexEqcode::after {
  content: "";
  display: table;
  clear: both;
}
.indexEqcode li {
  float: left;
  margin: 0 15px;
  list-style-type: none;
}
.indexEqcode .br {
  padding-right: 30px;
  border-right: 1px solid #f5f5f5;
}
.indexEqcode li .mt_40 {
  margin-top: 40px;
}
.indexEqcode li img {
  width: 120px;
  height: 120px;
  border-radius: 5px;
}
.indexEqcode li .wximg {
  width: 105px;
  height: 105px;
  border-radius: 5px;
  margin:10px 5px 5px ;
}
.indexEqcode li h3 {
  font-size: 16px;
  color: #333;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
}
.indexEqcode li h4 {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  color: #999;
}
.indexEqcode li h5 {
  text-align: center;
  font-size: 12px;
  padding: 5px 0;
}
.indexEqcode li .fansInfo {
  color: #333;
  font-size: 14px;
  margin: 65px 0;
}
.indexEqcode li .fansInfo p {
  height: 18px;
  line-height: 18px;
  text-align: center;
}
.indexEqcode li h6 {
  color: #999;
  text-align: center;
  font-size: 14px;
  height: 24px;
  line-height: 18px;
  font-weight: 500;
}
.el-button--warning:focus,
.el-button--warning:hover {
  background: #ffc984;
  border-color: #ffc984;
  color: #fff;
  opacity: 0.9;
}
.tabs {
  margin: 50px 30px 0px 155px;
}

.showDisable:hover {
  background-color: #eeeeee !important;
}

.showDisable {
  cursor: not-allowed !important;
  color: #8c939d;
  background-color: #eeeeee;
}

#closeMenu {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  box-shadow: 2px 4px 4px -4px rgba(0, 0, 0, 0.12),
    0 0 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  z-index: 99999;
  position: absolute;
  cursor: pointer;
}

#closeMenu ul {
  width: 150px;
  list-style-type: none;
}

#closeMenu ul li {
  padding: 8px 15px;
  font-size: 14px;
  color: #666;
  text-align: center;
}

#closeMenu ul li:hover {
  background-color: #409eff;
  color: #fff;
}
.printer {
  width: 22px;
  height: 22px;
  margin: 14px 10px;
  float: left;
  cursor: pointer;
}
.download {
  padding: 10px;
}
.downloadIcon {
  font-size: 19px;
  color: #aaa;
  width: 22px;
  height: 22px;
  line-height: 23px;
  margin: 9px 10px;
  float: left;
  cursor: pointer;
}
.printerList {
  padding: 12px 0 0 12px;
  min-width: 160px;
  p {
    margin: 0 -12px;
    padding: 0 12px 10px;
    font-weight: 700;
    border-bottom: 1px solid #ededed;
  }
  .el-radio {
    width: 100%;
    margin: 15px 0 0 0;
  }
  .printSpan {
    color: #999;
    font-size: 14px;
    padding: 10px 0 20px 0;
    float: left;
  }
}
.themeList {
  float: left;
  padding: 3px 8px;
  .li {
    width: 70px;
    height: 70px;
    background-blend-mode: normal, normal;
    float: left;
    margin-right: 10px;
    p {
      margin-top: 45px;
      width: 65px;
      height: 25px;
      line-height: 25px;
      font-size: 12px;
      padding-left: 5px;
      background-color: rgba(0, 0, 0, 0.1);
      color: #fff;
    }
    .span {
      width: 21px;
      height: 21px;
      text-align: center;
      color: #fff;
      border: solid 2px #ffffff;
      border-radius: 50%;
      position: absolute;
      margin-left: 51px;
      margin-top: -23px;
    }
  }
  .li:nth-child(1) .span {
    background-color: #fd5c8c;
  }
  .li:nth-child(2) .span {
    background-color: #ffc85f;
  }
  .li:nth-child(3) .span {
    background-color: #09d8fd;
  }
  .li:nth-child(4) .span {
    background-color: #e270f5;
  }
  .li:nth-child(5) .span {
    background-color: #ff822f;
  }
  .li:nth-child(6) .span {
    background-color: #333333;
  }
  .li:last-child {
    margin-right: 0;
  }
  .bg_1 {
    background-image: linear-gradient(0deg, #f52e69 0%, #fd5c8c 100%),
      linear-gradient(#fd5c8c, #fd5c8c);
  }
  .bg_2 {
    background-image: linear-gradient(
        0deg,
        #ff9c48 0%,
        #ffad42 100%,
        #ffbc51 100%,
        #ffca60 100%
      ),
      linear-gradient(#fd5c8c, #fd5c8c);
  }
  .bg_3 {
    background-image: linear-gradient(0deg, #5966fa 0%, #06dcfe 100%),
      linear-gradient(#fd5c8c, #fd5c8c);
  }
  .bg_4 {
    background-image: linear-gradient(0deg, #bb31d1 0%, #e472f6 100%),
      linear-gradient(#fd5c8c, #fd5c8c);
  }
  .bg_5 {
    background-image: linear-gradient(0deg, #ff5e55 0%, #ff832d 100%),
      linear-gradient(#fd5c8c, #fd5c8c);
  }
  .bg_6 {
    background-image: linear-gradient(0deg, #333333 0%, #555555 100%),
      linear-gradient(#fd5c8c, #fd5c8c);
  }
}
.topMenu {
  margin: 0;
  padding: 12px 20px 0 20px;
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
  .loginInfo {
    padding-bottom: 10px;
    border-bottom: 1px solid #f5f5f5;
    img {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      float: left;
    }
    h1 {
      font-size: 14px;
      height: 23px;
      line-height: 16px;
      color: #333333;
      position: relative;
      left: 10px;
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    h2 {
      font-size: 12px;
      height: 15px;
      line-height: 15px;
      color: #333333;
      position: relative;
      left: 10px;
      font-weight: 500;
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  ul {
    padding: 10px 0;
    list-style: none;
    border-bottom: 1px solid #f5f5f5;
    li {
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      span {
        padding-left: 25px;
      }
    }
  }
  .outLogin {
    padding: 15px 0;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    border-bottom: 1px solid #f5f5f5;
    img {
      width: 16px;
      height: 16px;
      position: absolute;
      margin: 7px 0 0 3px;
    }
    span {
      padding-left: 30px;
    }
    i {
      float: right;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
    }
    .moreIcon {
      font-size: 16px;
      width: 16px;
      height: 30px;
      position: absolute;
      text-align: left;
      padding: 0;
      line-height: 30px;
    }
  }
  .outLogin:last-child {
    border-bottom: 0;
  }
}
.topLi {
  text-align: center;
  width: 240px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  padding: 12px;
  img {
    width: 16px;
    height: 16px;
    position: absolute;
    margin-top: 7px;
  }
  span {
    padding-left: 30px;
    samp {
      cursor: pointer;
    }
  }
  label {
    samp {
      cursor: pointer;
    }
  }
}
.bespeakNum {
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  text-align: center;
  transform: scale(0.5);
  font-size: 16px;
  color: #fff;
  position: absolute;
  right: 117px;
  top: 5px;
}
.bespeakNumX {
  top: 81px !important;
}
.newAudio {
  opacity: 0;
}
.indexPrinter {
  margin-top: 12px;
  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
  .el-checkbox {
    margin-bottom: 12px;
    display: block;
    height: 20px;
    line-height: 20px;
  }
}
.comment_entrance {
  // position: relative;
  .printer {
    width: 19px;
    height: 19px;
    padding-top: 2px;
  }
  .comment_count {
    width: 18px;
    height: 18px;
    background-color: #fd5c8c;
    border: solid 2px #ffffff;
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 999px;
    font-size: 8px;
    color: white;
  }
}
.popover3_list {
  list-style: none;
  li {
    padding: 15px;
    font-size: 14px;
    color: #999999;
    cursor: pointer;
    display: flex;
    align-items: center;
    span {
      margin-left: 5px;
    }
    // &:hover{
    //     background: #409eff;
    // }
  }
}
.shopList {
  float: left;
  cursor: pointer;
  i {
    font-size: 19px;
    color: #aaa;
    width: 22px;
    height: 22px;
    line-height: 23px;
    text-align: center;
    margin: 9px;
    float: left;
  }
  span {
    float: left;
    color: #666;
    max-width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
<style>
.deskTabs .el-tabs--card > .el-tabs__header {
  border-bottom: 0 !important;
}
.deskTabs .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0 !important;
}
.deskTabs .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 0 !important;
  border-right: 0 !important;
}
.deskTabs {
  padding: 0px 360px 0px 0px;
  line-height: 38px;
  height: 40px;
}
</style>
